import styled from 'styled-components'

interface ISpendTrackerDepartmentCardStyledProps {}

export const SpendTrackerDepartmentCardStyled = styled.div<ISpendTrackerDepartmentCardStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
